import { Settings } from '@/generated/model/models'
export class Units {

  imperialLengthUnit: string = 'in'
  metricLengthUnit: string = 'mm'
  imperialWeightUnit: string = 'lbs'
  metricWeightUnit: string = 'grams'

  isImperial: boolean
  localLengthUnit: string
  localWeightUnit: string

  private units: Settings.UnitsEnum

  constructor(units: Settings.UnitsEnum) {
    this.units = units
    this.isImperial = this.units === Settings.UnitsEnum.IMPERIAL
    this.localLengthUnit = this.isImperial ? this.imperialLengthUnit : this.metricLengthUnit
    this.localWeightUnit = this.isImperial ? this.imperialWeightUnit : this.metricWeightUnit
  }

  toLocalLength = (systemValue?: number) => {
    if (!systemValue) {
      return systemValue
    }
    if (this.isImperial) {
      return this.toImperialLength(systemValue)
    }
    return systemValue
  }

  toImperialLength = (systemValue: number) => {
    // return Math.round(systemValue * 0.0393700787402)
    return Math.round(systemValue * 0.0393700787402 * 10) / 10
  }

  toSystemLength = (localizedValue?: number) => {
    localizedValue = localizedValue || 0
    if (this.isImperial) {
      return Math.round(localizedValue / 0.0393700787402)
    }
    return localizedValue
  }

  toLocalWeight = (systemValue?: number) => {
    if (!systemValue) {
      return systemValue
    }
    if (this.isImperial) {
      return this.toImperialWeight(systemValue)
    }
    return systemValue
  }

  toImperialWeight = (systemValue: number) => {
    return Math.round(systemValue * 0.00220462262185)
  }

  toSystemWeight = (localizedValue?: number) => {
    localizedValue = localizedValue || 0
    if (this.isImperial) {
      return Math.round(localizedValue / 0.00220462262185)
    }
    return localizedValue
  }

}

export default Units

